import 'reflect-metadata';
require('../bootstrap');
import ReportAbuse from './ReportAbuse';
import CalendarCarousel from './calendar/Carousel';
import ShowDoctorGallery from './ShowDoctorGallery';
import Practitioner from '../../app/models/Practitioner';
import ValidationMessagesFr from './ValidationMessagesFr';
import ValidationMessagesAr from './ValidationMessagesAr';
import { showMoreAppointmentsEvent } from './calendar/Appointment';
import getAlternativeAppointments from './calendar/AlternativeAppointments';
import { navigationControlEvent, onResizeReloadCalendar, calendarSwipeEvent, nextAvailability } from './calendar/Navigation';

// initialize first because it's utilized in other modules
window.doctori.validation = window.doctori.locale == 'fr' ? ValidationMessagesFr.fields : ValidationMessagesAr.fields;
window.doctori.messages   = window.doctori.locale == 'fr' ? ValidationMessagesFr.messages : ValidationMessagesAr.messages;


$(document).ready(function() {

    const practitioner = Practitioner.new(window.doctori.practitioner as {});

    //scroll menu
    $('.menu_info li a,.see_in_map').on('click', function() {
        var position = $('' + $(this).attr('href') + '').offset().top - 90;
        $('body, html').animate({
            scrollTop: position},
            400, function() {
            // after the animation is finished open the map accordion
            // that takes effect in mobile or in any window width up to 991px
            $('#carte .tab_title')[0].click();
        });
    });

    //scroll menu
    $('.ul_notice').on('click', function() {
        var position = $('' + $(this).attr('href') + '').offset().top - 90;
        $('body, html').animate({
            scrollTop: position},
            400, function() {
            // after the animation is finished open the map accordion
            // that takes effect in mobile or in any window width up to 991px
            $('#references .tab_title')[0].click();
        });
    });

    $('#scrollUpToCalendar').on('click', function() {
        $('.aside_doc_abonne')
            .attr('tabindex', -1)
            .focus();
        $('.cache_box').css('display', 'block');
        // $('.aside_content').css('z-index', '100');
    });

    var $height = $(window).scrollTop();
    var $my_height_2 = $('.div_info_doc').height();
    var $aside_content = $('.aside_content').height();
    $my_height_2 = $my_height_2 - $aside_content + 270;

    var width = $(window).width();
    if (width > 991 && $height < $my_height_2) {
        $('.abonne .aside_doc_abonne').click(function() {
            $('.cache_box').addClass('cache_box_show');
            $('.aside_content').css('z-index', '100');
            $('.VideoConsultation,.report_page ').css('opacity', '0');
        });

        $('.cache_box').click(
            function() {},
            function() {
                $('.cache_box').removeClass('cache_box_show');
                $('.VideoConsultation,.report_page ').css('opacity', '1');
            }
        );
    }

    // $(window).scrollTop($(window).scrollTop()+1);

    $('.menu_mobile').on('click', function() {
        $('.menu_info').toggleClass('open_menu');
    });

    $('.tab_title').on('click', function() {
        $('.tab_content').removeClass('show_tab');
        $('.tab_title').removeClass('tab-active');
        $(this)
            .next()
            .addClass('show_tab');
        $(this).addClass('tab-active');
    });

    //scroll profil docteur
    $(window).scroll(function() {
        var $my_height = 0;
        var $my_height = $('.navbar ').height();
        var $my_height = $my_height + $('.top_file_ariane ').height();

        var $height = $(window).scrollTop();
        if ($height > $my_height) {
            // $('.navbar').addClass('navbar-fixed-top');
            $('.header_doc_abonne').addClass('active_scroll');
            $('.aside_content').addClass('active_scroll_aside');
            $('.header_top_doc').addClass('header_top_scroll');
            $('.result_list').addClass('result_list_scroll');
        } else {
            // $('.navbar').removeClass('navbar-fixed-top');
            $('.header_doc_abonne').removeClass('active_scroll');
            $('.aside_content').removeClass('active_scroll_aside');
            $('.header_top_doc').removeClass('header_top_scroll');
            $('.result_list').removeClass('result_list_scroll');
        }

        var $prifix = 270;
        if ($('body').hasClass('non_abonne')) {
            $prifix = 220;
        }

        $my_height_2 = $('.div_info_doc').height();
        $aside_content = $('.aside_content').height();
        $my_height_2 = $my_height_2 - $aside_content + $prifix;

        if ($height > $my_height_2) {
            $('.aside_content').addClass('aside_absolute');
        } else {
            $('.aside_content').removeClass('aside_absolute');
        }
    });

    $('.show_hidde_menu').on('click', function() {
        $('.show_hidde_menu').toggleClass('open');
        $('.menu-left').toggleClass('collapse');
    });


    $("#disconnect").on('click', function(event) {
        event.preventDefault();

        $.ajax({
            url: window.doctori.paths.siteLoginUser,
            type: 'POST',
            cache: false,
            data: {
                action: 'logout'
            },
            beforeSend: function() {
                $("#disconnect").addClass('running');
            }
        })
        .done(function(response) {
            window.location = window.doctori.paths.siteUserIdentification;
        })
        .always(function() {
            $("#disconnect").removeClass('running');
        });
    });




    /*
    |--------------------------------------------------------------------------
    | Bind how more appointments click event
    |--------------------------------------------------------------------------
    */

    showMoreAppointmentsEvent();




    /*
    |--------------------------------------------------------------------------
    | Show phone number
    |--------------------------------------------------------------------------
    */

    // window.requestIdleCallback(ShowPhoneNumber);
    // ShowPhoneNumber();




    /*
    |--------------------------------------------------------------------------
    | Doctor map location
    |--------------------------------------------------------------------------
    */

    // setTimeout(function() {

    //  DoctorMapLocation();

    // }, 900);
    // window.requestIdleCallback(DoctorMapLocation);



    /*
    |--------------------------------------------------------------------------
    | Bind event to calendar controllers (arrows)
    |--------------------------------------------------------------------------
    */

    navigationControlEvent();




    /*
    |--------------------------------------------------------------------------
    | Bind event to calendar controllers (arrows)
    |--------------------------------------------------------------------------
    */

    CalendarCarousel.init();




    /*
    |--------------------------------------------------------------------------
    | Reload the calendar on window resize
    |--------------------------------------------------------------------------
    */

    onResizeReloadCalendar();




    /*
    |--------------------------------------------------------------------------
    | Reload the calendar on window resize
    |--------------------------------------------------------------------------
    */

    // window.requestIdleCallback(calendarSwipeEvent);
    calendarSwipeEvent();




    /*
    |--------------------------------------------------------------------------
    | Get alternative appointments
    |--------------------------------------------------------------------------
    */

    getAlternativeAppointments();
    // window.requestIdleCallback(getAlternativeAppointments);




    /*
    |--------------------------------------------------------------------------
    | Bind event to calendar controllers (arrows)
    |--------------------------------------------------------------------------
    */

    ReportAbuse();
    // window.requestIdleCallback(ReportAbuse);



    /*
    |--------------------------------------------------------------------------
    | Bind show doctor gallery
    |--------------------------------------------------------------------------
    */

    ShowDoctorGallery();
    // window.requestIdleCallback(ShowDoctorGallery);




    /*
    |--------------------------------------------------------------------------
    | nextAvailability
    |--------------------------------------------------------------------------
    */

    nextAvailability();


    /*
    |--------------------------------------------------------------------------
    | Fetch availabilities
    |--------------------------------------------------------------------------
    */

    if (practitioner.operating_business_days.length) {
        $(window).resize();
    }

    /*
    |--------------------------------------------------------------------------
    | Refresh practitioner calendar
    |--------------------------------------------------------------------------
    */

    function idleResize() {
        var t;
        window.onload = resetTimer;
        window.onmousemove = resetTimer;
        window.onmousedown = resetTimer;  // catches touchscreen presses as well
        window.ontouchstart = resetTimer; // catches touchscreen swipes as well
        window.ontouchmove = resetTimer;  // required by some devices
        window.onclick = resetTimer;      // catches touchpad clicks as well
        window.onkeydown = resetTimer;
        window.addEventListener('scroll', resetTimer, true); // improved; see comments

        function yourFunction() {
            console.log('yourFunction');
            $(window).resize();
        }

        function resetTimer() {
            clearTimeout(t);
            t = setTimeout(yourFunction, 1000*60);  // time is in milliseconds
        }
    }
    idleResize();
});
